<ng-container *transloco="let t">
  <div class="trace-id" data-testid="error-trace-id">
    <span class="trace-id__label">{{ t('errors.traceId.label') }}</span>
    <code class="trace-id__value" data-testid="error-trace-id-value">{{ traceId() }}</code>
    <button
      type="button"
      class="trace-id__copy"
      data-testid="error-trace-id-copy"
      [attr.aria-label]="t('errors.traceId.copy')"
      [title]="t('errors.traceId.copy')"
      (click)="copy()">
      {{ copied() ? t('errors.traceId.copied') : t('errors.traceId.copy') }}
    </button>
  </div>
</ng-container>
